import { BuyCrypto } from '@uikit/icons/BuyCrypto';
import { Calendar } from '@uikit/icons/Calendar';
import { Cup } from '@uikit/icons/Cup';

export const investors = [
  {
    name: 'KUCOIN LABS',
    image: {
      src: '/launchpad/stories/autolayer/auto-layer-story-investor-kucoin-labs.png',
      width: 340,
      height: 160,
    },
  },
  {
    name: 'MORNINGSTAR VENTURERS',
    image: {
      src: '/launchpad/stories/autolayer/auto-layer-story-investor-morningstar-ventures.png',
      width: 368,
      height: 160,
    },
  },
  {
    name: 'dewhales.capital',
    image: {
      src: '/launchpad/stories/autolayer/auto-layer-story-investor-dewhales-capital.png',
      width: 485,
      height: 160,
    },
  },
];

export const roadToIdoStat = {
  name: 'Road-to-IDO Distribution',
  stat: '10% on TGE, 3 months cliff, 7 months vesting',
};

export const stats = [
  {
    name: 'Road-to-IDO Prize Pool',
    stat: '$200,000 worth of $LAY3R',
    description: '0.95% from Total 32,000,000 Supply',
    Icon: Cup,
  },
  {
    name: 'Token Value',
    stat: '$0.65',
    description: 'IDO Price',
    Icon: BuyCrypto,
  },
  {
    name: 'Campaign Start',
    stat: 'May 23rd',
    description: 'IDO and TGE Estimated mid-June 2024',
    Icon: Calendar,
  },
];

export interface AutoLayerStoryReward {
  id: string;
  placement: string;
  prizePool: string;
  reward: string;
  allocation: string;
}

export const rewards: AutoLayerStoryReward[] = [
  {
    id: '1-499',
    placement: '1-499th Place',
    prizePool: '40% of the total prize',
    reward: '$80,000 in $LAY3R Tokens',
    allocation: '20 Raffle Tickets Per Person',
  },
  {
    id: '500-999',
    placement: '500-999th Place',
    prizePool: '30% of the total prize',
    reward: '$60,000 in $LAY3R Tokens',
    allocation: '10 Raffle Tickets Per Person',
  },
  {
    id: '1000-2499',
    placement: '1000-2499th Place',
    prizePool: '15% of the total prize',
    reward: '$30,000 in $LAY3R Tokens',
    allocation: '5 Raffle Tickets Per Person',
  },
  {
    id: '2500-5000',
    placement: '2500-5000th Place',
    prizePool: '10% of the total prize',
    reward: '$20,000 in $LAY3R Tokens',
    allocation: '2 Raffle Tickets Per Person',
  },
  {
    id: '5000+',
    placement: '5000th+',
    prizePool: '5% of the total prize',
    reward: '$10,000 in $LAY3R Tokens',
    allocation: '1 Raffle Ticket Per Person',
  },
];

export const AUTO_LAYER_CAMPAIGN_URL = 'https://zealy.io/cw/autolayer-road-to-ido-magic-square';
